import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation } from "@tanstack/react-query";
import { format } from "date-fns";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { createSession } from "services/Session.services";
import { z } from "zod";

import { buildPatientInformationSchema } from "./PatientInformation.schema";

export function usePatientInformation() {
  const navigate = useNavigate();

  //const { t } = useTranslation();
  const patientInformationSchema = buildPatientInformationSchema();
  const form = useForm<z.infer<typeof patientInformationSchema>>({
    resolver: zodResolver(patientInformationSchema),
    defaultValues: {
      firstName: "",
      lastName: "",
      birthDate: undefined,
      address: "",
      phone: "",
      identificationNumber: "",
      email: "",
    },
  });

  function onSubmit(values: z.infer<typeof patientInformationSchema>) {
    const submitData = {
      ...values,
      birthDate: values.birthDate ? format(new Date(values.birthDate), "yyyy-MM-dd") : undefined,
    };
    patientMutation.mutate(submitData);
  }

  const patientMutation = useMutation({
    mutationFn: createSession,
    onSuccess: (data) => {
      navigate(`/session/${data.id}`);
    },
  });

  return {
    form,
    onSubmit,
  };
}
